import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from './ui.js';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/** Top-level React error boundary (spec coding rule). */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error({ event: 'react_error_boundary', error, info });
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
          <div className="card max-w-md p-8 text-center">
            <div className="mb-4 text-xs font-semibold uppercase tracking-widest text-red-600">
              Error
            </div>
            <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">
              Something went wrong
            </h1>
            <p className="mt-3 text-slate-600">{this.state.error.message}</p>
            <Button className="mt-6" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
